module.exports = "<div>\r\n    <fp-alert class=\"text-center\" data-name=\"{{ $ctrl.alertName }}\"></fp-alert>\r\n    <ui-view></ui-view>\r\n</div>";